import z from 'zod';

const getRejectedReceiptsAll = {
  body: z.never(),
  response: z.array(
    z.object({
      id: z.number(),
      part: z.number(),
      part_number: z.string(),
      supplier: z.number().nullable(),
      supplier_name: z.string().nullable(),
      quantity: z.number(),
      qc_notes: z.string().optional(),
      inspected_by: z.object({
        id: z.number(),
        display_name: z.string(),
      }),
      inspected_at: z.date(),
    }),
  ),
  params: z.object({
    project_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getRejectedReceiptsAllSchema = z.object(getRejectedReceiptsAll);
export type GetRejectedReceiptsAll = z.infer<
  typeof getRejectedReceiptsAllSchema
>;

const exportRejectedInventory = {
  body: z.never(),
  response: z.any(),
  params: z.object({
    project_id: z.coerce.number(),
  }),
  query: z.never(),
};
const exportRejectedInventorySchema = z.object(exportRejectedInventory);
export type ExportRejectedInventory = z.infer<
  typeof exportRejectedInventorySchema
>;
